import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=2c4407c2&scoped=true"
import script from "./Employees.vue?vue&type=script&setup=true&lang=js"
export * from "./Employees.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Employees.vue?vue&type=style&index=0&id=2c4407c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_1d815c3a82e414dc02ba46af5dbd33b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4407c2",
  null
  
)

export default component.exports